export default (model) => {
  if (undefined === model || null === model) {
    return null;
  }

  if (typeof model === 'string' || typeof model === 'number') {
    return model;
  }

  if (model.hasOwnProperty('id')) {
    return model.id;
  }

  throw new Error('Can not extract id from model.');
}
